import { isPlatformBrowser } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    Input,
    OnInit,
    PLATFORM_ID,
    inject,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from 'app/core/pipe/translate.pipe';
import { ConsentService } from 'app/core/services/analytics/consent.service';
import { TenantConfigService } from 'app/core/tenant/tenant-config.service';

/**
 * First-visit analytics consent banner. Shown once until the user accepts or
 * declines; the decision is persisted and applied to Clarity via ConsentService.
 */
@Component({
    selector: 'app-consent-banner',
    standalone: true,
    imports: [MatButtonModule, MatIconModule, TranslatePipe],
    templateUrl: './consent-banner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConsentBannerComponent implements OnInit {
    @Input() testId = 'consent-banner';

    visible = false;

    /** Tenant brand name, injected into the banner copy via translate params. */
    tenantName = '';

    private readonly consentService = inject(ConsentService);
    private readonly tenantConfig = inject(TenantConfigService);

    constructor(@Inject(PLATFORM_ID) private readonly platformId: object) {}

    ngOnInit(): void {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        this.tenantName =
            this.tenantConfig.safeGetConfig()?.identity.displayName ?? '';
        // Re-apply any prior decision, then only show the banner to users who
        // have not chosen yet.
        this.consentService.applyStoredConsent();
        this.visible = !this.consentService.hasDecided();
    }

    onAccept(): void {
        this.consentService.setConsent(true);
        this.visible = false;
    }

    onDecline(): void {
        this.consentService.setConsent(false);
        this.visible = false;
    }
}
